import { useForm, FormProvider, FieldValues } from 'react-hook-form';
import { FormField } from './FormField';
import { FormProps } from './form.types';

export const Form = <T extends FieldValues>({
  config,
  onSubmit,
  children,
  className,
}: FormProps<T>) => {
  const methods = useForm<T>(config);

  return (
    <FormProvider {...methods}>
      <form className={className} onSubmit={methods.handleSubmit(onSubmit)} noValidate>
        {typeof children === 'function' ? children(methods) : children}
      </form>
    </FormProvider>
  );
};

// Attached Form components
Form.Field = FormField;
